module.exports = __webpack_public_path__ + "static/media/alert-octagon.908e8983.svg";